import React, { Component } from 'react';
import { HomeOutlined, MailOutlined, SettingOutlined, CreditCardOutlined, TeamOutlined, LineChartOutlined } from '@ant-design/icons';
import Inherit from '../../../core/inherit';
import withHooks from '../../../core/withHooks';
import NewSidebarController from './newSidebar.controller';
import styles from './styles/newSidebar.module.scss';

class NewSidebar extends Inherit(NewSidebarController, Component) {
    state = {
        activeItem: '',
        isCollapsed: false // Start collapsed by default
    };

    render() {
        const { activeItem, isCollapsed } = this.state;

        const menuItems = [
            {
                key: 'home',
                label: 'Home',
                icon: <HomeOutlined style={{ fontSize: '14px' }} />
            },
            {
                key: 'cashflow',
                label: 'Cashflow Management',
                icon: <MailOutlined style={{ fontSize: '14px' }} />
            },
            {
                key: 'configurations',
                label: 'Configurations',
                icon: <SettingOutlined style={{ fontSize: '14px' }} />
            },
            {
                key: 'billing',
                label: 'Billing',
                icon: <CreditCardOutlined style={{ fontSize: '14px' }} />
            },
            {
                key: 'team',
                label: 'Team',
                icon: <TeamOutlined style={{ fontSize: '14px' }} />
            },
            {
                key: 'reports',
                label: 'Reports',
                icon: <LineChartOutlined style={{ fontSize: '14px' }} />
            }
        ];

        return (
            <div 
                className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''}`}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <nav className={styles.navigation}>
                    {menuItems.map((item) => (
                        <button
                            key={item.key}
                            className={`${styles.navItem} ${activeItem === item.key ? styles.active : ''}`}
                            onClick={() => this.handleItemClick(item.key)}
                            title={isCollapsed ? item.label : ''}
                        >
                            <div className={styles.iconContainer}>
                                {item.icon}
                            </div>
                            {!isCollapsed && <span className={styles.label}>{item.label}</span>}
                        </button>
                    ))}
                </nav>
            </div>
        );
    }
}

export default withHooks(NewSidebar);
